@if (appService.loading) {
  <div class="loading-screen-wrapper">
    <div class="loading-screen-icon">
      <app-loading-screen-default />
    </div>
  </div>
}
